function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "step_3_svg__e",
  d: "M.499.798h59.655V104.28H.499z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M.443 24.856v25.16c0 13.448 10.9 24.348 24.348 24.348 13.447 0 24.349-10.494 24.349-23.941V24.856C49.14 11.409 38.238.508 24.79.508 11.345.508.444 11.408.444 24.856z",
  id: "step_3_svg__g"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 25.065v25.16C0 63.67 10.901 74.572 24.348 74.572c13.448 0 24.35-10.902 24.35-24.349v-25.16c0-13.446-10.902-24.348-24.35-24.348C10.901.716 0 11.618 0 25.065",
  id: "step_3_svg__i"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.962.985C17.49.985 6.443 11.335 5.32 24.515a5.176 5.176 0 00-5.08 5.171c0 2.86 2.32 5.18 5.18 5.18.365 0 .72-.04 1.063-.112 2.682 8.233 9.392 14.64 17.808 16.891v5.15c0 3.825 2.848 7.333 6.899 7.333 4.05 0 6.9-3.508 6.9-7.334v-5.149c8.462-2.265 15.205-8.73 17.853-17.03.482.148.983.251 1.512.251a5.18 5.18 0 005.18-5.18 5.179 5.179 0 00-5.18-5.18c-.134 0-.26.029-.39.04C55.953 11.35 44.9.985 31.418.985",
  id: "step_3_svg__k"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.962.985C17.49.985 6.443 11.335 5.32 24.515a5.176 5.176 0 00-5.08 5.171c0 2.86 2.32 5.18 5.18 5.18.365 0 .72-.04 1.063-.112 2.682 8.233 9.392 14.64 17.808 16.891v5.15c0 3.825 2.848 7.333 6.899 7.333 4.05 0 6.9-3.508 6.9-7.334v-5.149c8.462-2.265 15.205-8.73 17.853-17.03.482.148.983.251 1.512.251a5.18 5.18 0 005.18-5.18 5.179 5.179 0 00-5.18-5.18c-.134 0-.26.029-.39.04C55.953 11.35 44.9.985 31.418.985h-.457z",
  id: "step_3_svg__m"
}), /*#__PURE__*/React.createElement("filter", {
  x: "-50%",
  y: "-50%",
  width: "200%",
  height: "200%",
  filterUnits: "objectBoundingBox",
  id: "step_3_svg__a"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 16.807,
  "in": "SourceGraphic"
})), /*#__PURE__*/React.createElement("filter", {
  x: "-4.6%",
  y: "-3.3%",
  width: "109.2%",
  height: "109.2%",
  filterUnits: "objectBoundingBox",
  id: "step_3_svg__c"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 2,
  "in": "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2,
  "in": "shadowOffsetOuter1",
  result: "shadowBlurOuter1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.239215686 0 0 0 0 0.796078431 0 0 0 0 0.274509804 0 0 0 0.98666958 0",
  "in": "shadowBlurOuter1"
})), /*#__PURE__*/React.createElement("circle", {
  id: "step_3_svg__b",
  cx: 76.5,
  cy: 76.5,
  r: 76.5
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 176 0)"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#F9BA48",
  strokeWidth: 2,
  cx: 146.484,
  cy: 21.363,
  r: 5.5
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  cx: 18.714,
  cy: 6,
  r: 6
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.855 146.342c.703 0 1.273.637 1.273 1.422v3.941l3.942.001c.74 0 1.347.505 1.416 1.15l.006.123c0 .703-.637 1.273-1.422 1.273H8.127l.001 3.942c0 .739-.505 1.346-1.15 1.415l-.123.007c-.703 0-1.272-.637-1.272-1.422v-3.943H1.64c-.74 0-1.347-.504-1.416-1.15l-.006-.122c0-.703.636-1.273 1.422-1.273h3.941v-3.942c0-.739.505-1.346 1.15-1.415z",
  fill: "#0086D8",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#45C94E",
  strokeWidth: 2,
  cx: 125.964,
  cy: 158.902,
  r: 5.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M161.873 99.42c.703 0 1.273.636 1.273 1.421v3.941l3.942.001c.74 0 1.347.505 1.416 1.15l.006.123c0 .703-.637 1.273-1.422 1.273h-3.943l.001 3.942c0 .739-.505 1.346-1.15 1.415l-.123.007c-.703 0-1.273-.637-1.273-1.422v-3.943h-3.941c-.74 0-1.347-.504-1.416-1.15l-.007-.122c0-.703.637-1.273 1.423-1.273h3.941v-3.942c0-.739.505-1.346 1.15-1.415z",
  fill: "#DA4D7A",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 6)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.615 .154)"
}, /*#__PURE__*/React.createElement("circle", {
  filter: "url(#step_3_svg__a)",
  cx: 77.42,
  cy: 103.42,
  r: 50.42
}), /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__b"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#step_3_svg__c)",
  xlinkHref: "#step_3_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fill: "#3DCB46",
  xlinkHref: "#step_3_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  fillOpacity: 0.9,
  fill: "#FFF",
  xlinkHref: "#step_3_svg__b"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#DA4D7A",
  mask: "url(#step_3_svg__d)",
  cx: 109.154,
  cy: 84.615,
  r: 29.231
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0086D8",
  mask: "url(#step_3_svg__d)",
  d: "M21.462 129.231H143v26.154H21.462z"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#step_3_svg__d)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(42.4 20.269)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M60.154 74.452c0 16.473-13.354 29.828-29.827 29.828C13.853 104.28.499 90.925.499 74.452V30.625C.499 14.152 13.853.797 30.327.797c16.473 0 29.827 13.355 29.827 29.828v43.827z",
  fill: "#96540A",
  mask: "url(#step_3_svg__f)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M57.914 113.186a4.87 4.87 0 00-9.74 0v62.494a4.87 4.87 0 009.74 0v-62.494z",
  fill: "#F5B88C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.871 113.186a4.87 4.87 0 00-9.74 0v62.494a4.87 4.87 0 009.74 0v-62.494z",
  fill: "#F4AC7F"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#AC5E4C",
  strokeWidth: 5.747,
  strokeLinecap: "round",
  d: "M59.943 254.814V144.84"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#804D4B",
  strokeWidth: 5.747,
  strokeLinecap: "round",
  d: "M85.103 254.814V144.84"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.45 142.81V260.09h12.986v-93.743c4.239 1.016 7.934 1.116 12.174 0v93.743h12.986V142.81H53.45z",
  fill: "#E5E5E4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#B3B2B3",
  d: "M78.61 157.014v102.67h12.986v-102.67z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(47.732 92.793)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  d: "M30.878 82.075H18.704v-8.521c4.24 1.014 7.935 1.115 12.174 0v8.521zm5.866-32.059c-1.59 11.911-11.78 21.103-24.127 21.103a24.34 24.34 0 01-6.899-.998v12.36h38.146V50.017h-7.12z",
  fill: "#C5C5C5",
  mask: "url(#step_3_svg__h)"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#009891"
}, /*#__PURE__*/React.createElement("path", {
  d: "M53.45 142.81h38.145v-27.596H53.45z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.865 113.162c-.134-13.264-10.868-23.92-24.163-23.92-13.298 0-24.383 10.656-24.521 23.92l5.269 2.459h38.146l5.27-2.46z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(36 88.527)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  d: "M36.701.715c-13.297 0-24.38 10.656-24.52 23.92l5.27 2.458v27.19h43.42V24.885c0-13.38-10.79-24.17-24.17-24.17",
  fill: "#00A89C",
  mask: "url(#step_3_svg__j)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M42.696 51.096c0-16.471 13.354-29.827 29.827-29.827 16.473 0 29.827 13.356 29.827 29.827 0 16.473-13.354 29.828-29.827 29.828-16.473 0-29.827-13.355-29.827-29.828",
  fill: "#BC6B11"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.333 33.067)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__l",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__k"
})), /*#__PURE__*/React.createElement("path", {
  d: "M57.456 24.505c-.135 0-.26.029-.393.04C55.953 11.35 44.9.985 31.42.985h-.457C17.49.985 6.443 11.335 5.32 24.515a5.175 5.175 0 101.164 10.239c2.68 8.232 9.393 14.64 17.808 16.891v5.149c0 3.826 2.847 7.333 6.898 7.333 4.05 0 6.9-3.507 6.9-7.333v-5.149c8.462-2.265 15.205-8.73 17.854-17.03.481.148.982.25 1.512.25a5.18 5.18 0 100-10.36",
  fill: "#F4AC7F",
  mask: "url(#step_3_svg__l)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(41.333 33.067)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "step_3_svg__n",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#step_3_svg__m"
})), /*#__PURE__*/React.createElement("path", {
  d: "M49.452 23.076c0-14.217-11.526-25.743-25.743-25.743h-.458C9.033-2.667-2.492 8.86-2.492 23.076v.051c0 14.218 11.525 25.745 25.743 25.745h.458c14.217 0 25.743-11.527 25.743-25.745v-.05z",
  fill: "#F5B88C",
  mask: "url(#step_3_svg__n)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M79.4 71.257a10.477 10.477 0 01-6.84 2.528c-2.612 0-5.001-.951-6.84-2.528",
  stroke: "#D47742",
  strokeWidth: 0.603,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M85.453 55.367c0 1.393-.725 2.534-1.611 2.534s-1.612-1.14-1.612-2.534c0-1.392.726-2.533 1.612-2.533.886 0 1.611 1.14 1.611 2.533M63.35 55.367c0 1.393-.725 2.534-1.612 2.534-.886 0-1.611-1.14-1.611-2.534 0-1.392.725-2.533 1.611-2.533.887 0 1.612 1.14 1.612 2.533",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.914 34.052c5.276 10.552 27.595 21.915 41.798 16.233 2.435-6.087-.405-7.305-.405-7.305l-16.64-14.203-24.753 5.275z",
  fill: "#BC6B11"
}), /*#__PURE__*/React.createElement("path", {
  d: "M72.523 28.98c14.669 0 26.676 11.365 27.716 25.769.049-.671.082-1.346.082-2.029 0-15.353-12.445-27.798-27.798-27.798-15.352 0-27.797 12.445-27.797 27.798 0 .683.033 1.358.08 2.029 1.04-14.404 13.048-25.769 27.717-25.769",
  fill: "#35F2E5"
})))), /*#__PURE__*/React.createElement("circle", {
  fill: "#45C94E",
  cx: 25,
  cy: 52,
  r: 25
}), /*#__PURE__*/React.createElement("text", {
  fontFamily: "ProximaNova-Bold, Proxima Nova",
  fontSize: 25,
  fontWeight: "bold",
  letterSpacing: -0.417,
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 15.948,
  y: 57.654
}, "3"))));

function SvgStep3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 166,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/step_3.46b26400.svg";
export { SvgStep3 as ReactComponent };